import { Injectable } from '@angular/core';
import { IStoreBase } from '@boxx/core';
import {
  IMessagesStateSuccess,
  IMessagesStateError,
} from '@boxx/messages-core';
import { Store } from '@ngrx/store';
import { ReviewModel } from '../../models/Review.model';
import * as fromReviewsActions from '../actions/reviews.actions';
import * as fromReducer from '../messages.reducer';
import { IReviewsStateData } from '../messages.reducer';
import * as fromReviewsSelector from '../selectors/reviews.selectors';

@Injectable()
export class ReviewsStore
  implements
    IStoreBase<ReviewModel[], IMessagesStateSuccess, IMessagesStateError>
{
  constructor(public store: Store<fromReducer.MessagesState>) {}

  get state$() {
    return this.store.select(fromReviewsSelector.reviewsState);
  }
  get data$() {
    return this.store.select(fromReviewsSelector.reviewsData);
  }
  get loading$() {
    return this.store.select(fromReviewsSelector.reviewsIsLoading);
  }
  get success$() {
    return this.store.select(fromReviewsSelector.reviewsSuccess);
  }
  get error$() {
    return this.store.select(fromReviewsSelector.reviewsError);
  }
  get fetched$() {
    return this.store.select(fromReviewsSelector.reviewsHasBeenFetched);
  }

  fetch() {
    this.store.dispatch(fromReviewsActions.getReviewsBeginAction());
  }

  upsertReply(review: ReviewModel, comment: string) {
    this.store.dispatch(
      fromReviewsActions.upsertReviewReplyBeginAction({ review, comment })
    );
  }

  deleteReply(reviewId: string) {
    this.store.dispatch(
      fromReviewsActions.deleteReviewReplyBeginAction({ reviewId })
    );
  }
}
